import { Component, OnInit, inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators, ReactiveFormsModule } from "@angular/forms";
import { AuthService } from "../../../services/auth/auth.service";
import { Router } from "@angular/router";
import { TranslateService, TranslateModule } from "@ngx-translate/core";
import { MetaDataService } from "../../../services/meta/meta-data.service";
import { ImageManager } from "../../../shared/image-manager";


@Component({
    selector: 'xplorer-bowser-forgot-password-page',
    templateUrl: './forgot-password-page.component.html',
    styleUrls: ['./forgot-password-page.component.css'],
    imports: [ReactiveFormsModule, TranslateModule]
})
export class ForgotPasswordPageComponent implements OnInit {
  forgotPasswordForm: FormGroup;
  isSubmitting = false;
  showSuccessMessage = false;
  showErrorMessage = false;
  errorMessage: string;

  private fb: FormBuilder = inject(FormBuilder);
  private authService: AuthService = inject(AuthService);
  private router: Router = inject(Router);
  private translateService: TranslateService = inject(TranslateService);
  private metaDataService: MetaDataService = inject(MetaDataService);


  ngOnInit(): void {
    this.metaDataService.setDefaultMetaData();
    this.buildForm();
  }

  onSubmit() {
    if (this.forgotPasswordForm.invalid || this.isSubmitting) {
      this.forgotPasswordForm.markAllAsTouched();
      return;
    }

    this.isSubmitting = true;
    this.showSuccessMessage = false;
    this.showErrorMessage = false;

    const email = this.forgotPasswordForm.value.email;

    this.authService.forgotPassword(email).subscribe({
      next: () => {
        this.isSubmitting = false;
        this.showSuccessMessage = true;
      },
      error: (error) => {
        this.isSubmitting = false;
        this.errorMessage = error?.error?.message || this.translateService.instant('forgot_password.error_message');
        this.showErrorMessage = true;
      }
    });
  }

  goToLogin() {
    this.router.navigate(['login']);
  }

  backToHome() {
    this.router.navigate(['']);
  }

  get emailControl() {
    return this.forgotPasswordForm.get('email');
  }

  private buildForm() {
    this.forgotPasswordForm = this.fb.group({
      email: ['', [Validators.required, Validators.email]]
    });
  }

  protected readonly ImageManager = ImageManager;
}

